import { Box, PrimaryButton, Stack } from "flicket-ui";
import { ReactNode } from "react";
import { useAtom } from "jotai";

import { useExpressCheckoutContext } from "~features/checkout/express/components/ExpressCheckout.context";
import { isPrechargeFlowAtom } from "~features/nonseated-reservation/isPrechargeFlowAtom";
import { ExpressCheckoutFooter } from "./ExpressCheckoutFooter";
import { CreateOrderOptions } from "~hooks/reservation/useCreateOrder";

interface FooterActionBarProps {
  priceInfo: ReactNode;
  buttonText: string;
  onAction: (options?: CreateOrderOptions) => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const FooterActionBar = ({
  priceInfo,
  buttonText,
  onAction,
  isLoading,
  isDisabled,
}: FooterActionBarProps) => {
  const [isPrechargeFlow] = useAtom(isPrechargeFlowAtom);
  const expressCheckoutContext = useExpressCheckoutContext();

  const showExpressCheckout = !isPrechargeFlow && !!expressCheckoutContext;

  if (showExpressCheckout) {
    return (
      <ExpressCheckoutFooter
        priceInfo={priceInfo}
        buttonText={buttonText}
        onAction={onAction}
        isLoading={isLoading}
        isDisabled={isDisabled}
      />
    );
  }

  return (
    <Stack
      width="100%"
      alignItems={"center"}
      justifyContent={"space-between"}
      gap={2}
      direction={"horizontal"}
    >
      <Box>{priceInfo}</Box>

      <PrimaryButton
        flex={1}
        maxW={"330px"}
        onClick={() => void onAction()}
        isLoading={isLoading}
        disabled={isDisabled}
      >
        {buttonText}
      </PrimaryButton>
    </Stack>
  );
};
